import script from "./order_list_table.vue?vue&type=script&setup=true&lang=js"
export * from "./order_list_table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__